import { useI18n } from '@/lib/i18n';
import TrustpilotLogo from '@images/Trustpilot-Logo.svg';
import TrustpilotStars from '@images/Trustpilot-Stars.svg';

export default function ReviewsCard({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n();
  const score = 4.5;
  const reviews = 151;

  return compact ? (
    <div className={`flex items-center justify-around space-x-1 rounded border border-black/10 bg-white p-1 md:p-1.5`}>
      <div>
        <img src={TrustpilotStars} alt={'Trustpilot Stars'} className="h-auto w-16 sm:w-20" />
      </div>

      <div className="text-xs font-semibold sm:text-xs">{score}</div>
    </div>
  ) : (
    <div className={`flex items-center justify-around space-x-2 rounded bg-white p-3 shadow`}>
      <div>
        <img src={TrustpilotLogo} alt={'Trustpilot Logo'} className="h-auto w-12 sm:w-16" />
      </div>

      <div>
        <img src={TrustpilotStars} alt={'Trustpilot Stars'} className="h-auto w-16 sm:w-20" />
      </div>

      <div className="text-xs sm:text-xs">
        TrustScore <strong>{score}</strong>
        <span className="px-1">|</span>
        <strong>{reviews}</strong> <span className="lowercase">{t('layout.Reviews')}</span>
      </div>
    </div>
  );
}
